import { api } from "./api";

export type NotificationItem = {
    id: string;
    title: string;
    message: string;
    type?: string;
    read?: boolean;
    read_at?: string | null;
    created_at?: string;
    company_id?: string;
    company?: {
        id?: string;
        _id?: string;
        name?: string;
        title?: string;
    } | null;
    reference_type?: string;
    reference_id?: string;
    payload_jsonb?: any;
};

export type NotificationListResponse = {
    items: NotificationItem[];
    total: number;
    unread: number;
    page: number;
    limit: number;
};

export type NotificationListParams = {
    page?: number;
    limit?: number;
    read?: boolean;
    companyId?: string | null;
    type?: string | null;
};

export const GET_NOTIFICATIONS = async ({ page = 0, limit = 20, read, companyId, type }: NotificationListParams = {}) => {
    const params: Record<string, any> = {
        page,
        limit,
        ...(typeof read === "boolean" ? { read } : {}),
        ...(companyId ? { company: companyId, company_id: companyId } : {}),
        ...(type ? { type } : {}),
    };

    const { data } = await api.get("/notifications", { params });
    return data as NotificationListResponse;
};

export const READ_NOTIFICATION = async (id: string) => {
    const { data } = await api.patch(`/notifications/${id}/read`);
    return data as NotificationItem;
};